const onLogout = () => {
    document.cookie = 'student-dashboard-grade= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';
    localStorage.removeItem('passwordConfirmedToken');
    localStorage.removeItem('passwordConfirmedTokenExpiry');
};

export default onLogout;
